export default "__VITE_ASSET__B$esFV$l__"